import React from "react";
import { MdFilterListOff } from "react-icons/md";

const MemoireFilters = ({ filters, onFilterChange, onResetFilters }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ [name]: value === "" ? null : value });
  };

  return (
    <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-medium text-gray-700">Filtres avancés</h3>
        <button
          onClick={onResetFilters}
          className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900"
        >
          <MdFilterListOff className="h-4 w-4" />
          <span>Réinitialiser</span>
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-5">
        <div>
          <label htmlFor="annee" className="block text-xs font-medium text-gray-700">
            Année académique
          </label>
          <input
            type="number"
            id="annee"
            name="annee"
            min="1900"
            max="2100"
            value={filters.annee || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
            placeholder="Ex: 2024"
          />
        </div>
        <div>
          <label htmlFor="filiere" className="block text-xs font-medium text-gray-700">
            Filière
          </label>
          <input
            type="text"
            id="filiere"
            name="filiere"
            value={filters.filiere || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
            placeholder="Ex: Informatique"
          />
        </div>
        <div>
          <label htmlFor="etablissement" className="block text-xs font-medium text-gray-700">
            Établissement
          </label>
          <input
            type="text"
            id="etablissement"
            name="etablissement"
            value={filters.etablissement || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
            placeholder="Ex: Université"
          />
        </div>
        <div>
          <label htmlFor="dateStart" className="block text-xs font-medium text-gray-700">
            Date début
          </label>
          <input
            type="date"
            id="dateStart"
            name="dateStart"
            value={filters.dateStart || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          />
        </div>
        <div>
          <label htmlFor="dateEnd" className="block text-xs font-medium text-gray-700">
            Date fin
          </label>
          <input
            type="date"
            id="dateEnd"
            name="dateEnd"
            value={filters.dateEnd || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          />
        </div>
      </div>
    </div>
  );
};

export default MemoireFilters;